<template>
    <div class="newsfeed-form">
        <header>
            <h3>
                {{ title }}
            </h3>

            <div class="controls">
                <button
                    class="btn-danger"
                    @click="$emit('cancel')"
                >
                    Cancel
                </button>

                <button
                    class="btn-secondary disabled"
                    @click="$emit('draft')"
                >
                    Save as draft
                </button>

                <button
                    class="btn-secondary"
                    @click="$emit('publish')"
                >
                    Publish
                </button>
            </div>
        </header>

        <section>
            <div>
                <div class="input-wrapper">
                    <label>
                        Post Title
                    </label>

                    <input
                        type="text"
                        placeholder="Enter title"
                        v-model="newsfeed.title"
                    >
                </div>

                <div class="input-wrapper">
                    <label>
                        Post Type
                    </label>

                    <div class="input-group">
                        <label class="radio-input">
                            <input
                                type="radio"
                                name="post-type"
                                v-model="newsfeed.type"
                                value="main"
                            >

                            <span>
                                Main
                            </span>
                        </label>

                        <label class="radio-input">
                            <input
                                type="radio"
                                name="post-type"
                                v-model="newsfeed.type"
                                value="mid"
                            >

                            <span>
                                Mid
                            </span>
                        </label>

                        <label class="radio-input">
                            <input
                                type="radio"
                                name="post-type"
                                v-model="newsfeed.type"
                                value="subtag"
                            >

                            <span>
                                Subtag
                            </span>
                        </label>
                    </div>
                </div>

                <div v-if="newsfeed.type === 'main'">
                    <div class="input-wrapper">
                        <label>
                            Category Name
                        </label>

                        <div class="dropdown-wrapper">
                            <dropdown-list
                                v-if="showCategoryList"
                                :items="options.tags.category"
                                :is-loading="false"
                                :is-searchable="false"
                                @select="selectTag('emotion', $event)"
                            >
                            </dropdown-list>
                        </div>

                        <custom-tags-input
                            :items="newsfeed.tags.category"
                            :input-limit="16"
                            placeholder="Add Category"
                            @remove="removeTag('category', $event)"
                            @input="inputTag('category', $event)"
                            @enter="selectTag('category', $event)"
                            @click="showCategoryList = !showCategoryList"
                        >
                        </custom-tags-input>

                        <p class="limit">
                            {{ `${Math.min(16, categoryNameInputLength)}/16` }}
                        </p>
                    </div>
                </div>

                <div class="input-wrapper">
                    <label>
                        Post Description
                    </label>

                    <input
                        type="text"
                        placeholder="Enter description"
                        v-model="newsfeed.description"
                        maxlength="20"
                    >

                    <p class="limit">
                        {{ `${Math.min(20, newsfeed.description.length)}/20` }}
                    </p>
                </div>

                <div class="input-wrapper">
                    <label>
                        Post Content
                    </label>

                    <textarea
                        placeholder="Enter content"
                    ></textarea>
                </div>

                <div class="input-wrapper">
                    <label>
                        Emotion Tag
                    </label>

                    <div class="dropdown-wrapper">
                        <dropdown-list
                            v-if="showEmotionList"
                            :items="options.tags.emotion"
                            :is-loading="false"
                            :is-searchable="false"
                            @select="selectTag('emotion', $event)"
                        >
                        </dropdown-list>
                    </div>

                    <custom-tags-input
                        :items="newsfeed.tags.emotion"
                        placeholder="Select Tag"
                        @remove="removeTag('emotion', $event)"
                        @input="inputTag('emotion', $event)"
                        @enter="selectTag('emotion', $event)"
                        @click="showEmotionList = !showEmotionList"
                    >
                    </custom-tags-input>
                </div>

                <div class="input-wrapper">
                    <label>
                        Activity Tag
                    </label>

                    <div class="dropdown-wrapper">
                        <dropdown-list
                            v-if="showActivityList"
                            :items="options.tags.activity"
                            :is-loading="false"
                            :is-searchable="false"
                            @select="selectTag('activity', $event)"
                        >
                        </dropdown-list>
                    </div>

                    <custom-tags-input
                        :items="newsfeed.tags.activity"
                        placeholder="Select Tag"
                        @remove="removeTag('activity', $event)"
                        @input="inputTag('activity', $event)"
                        @enter="selectTag('activity', $event)"
                        @click="showActivityList = !showActivityList"
                    >
                    </custom-tags-input>
                </div>

                <div
                    class="input-wrapper"
                    v-if="newsfeed.type && newsfeed.type !== 'mid'"
                >
                    <label>
                        Subtag
                    </label>

                    <div class="dropdown-wrapper">
                        <dropdown-list
                            v-if="showSubtagList"
                            :items="options.tags.subtag"
                            :is-loading="false"
                            :is-searchable="false"
                            @select="selectTag('activity', $event)"
                        >
                        </dropdown-list>
                    </div>

                    <custom-tags-input
                        :items="newsfeed.tags.subtag"
                        placeholder="Select Tag"
                        @remove="removeTag('subtag', $event)"
                        @input="inputTag('subtag', $event)"
                        @enter="selectTag('subtag', $event)"
                        @click="showSubtagList = !showSubtagList"
                    >
                    </custom-tags-input>
                </div>
            </div>

            <div>

                <div class="input-wrapper">
                    <label>
                        Post Date
                    </label>

                    <div class="input-group">
                        <!-- <input type="date"> -->

                        <!-- <input type="time"> -->

                        <date-picker
                            v-model="newsfeed.date"
                            format="YYYY-MM-DD"
                            type="date"
                            placeholder="Select date"
                        ></date-picker>

                        <date-picker
                            v-model="newsfeed.time"
                            type="time"
                            placeholder="Select time"
                        ></date-picker>
                    </div>
                </div>

                <div class="upload-media-wrapper">
                    <div class="upload-media">
                        <h4>
                            Upload media thumbnail
                        </h4>

                        <p>
                            This will be seen by the user in the feed
                        </p>

                        <custom-file-input
                            label="Select or drop to upload media"
                            v-model="newsfeed.media.thumbnail"
                            @remove="newsfeed.media.thumbnail = null"
                        ></custom-file-input>
                    </div>

                    <div class="upload-media">
                        <h4>
                            Upload media content
                        </h4>

                        <p>
                            This will be seen by the user inside the post
                        </p>

                        <custom-file-input
                            label="Select or drop to upload media"
                            v-model="newsfeed.media.content"
                            @remove="newsfeed.media.content = null"
                        ></custom-file-input>
                    </div>
                </div>
            </div>
        </section>
    </div>
</template>

<script>
import CustomTagsInput from '@/components/utils/CustomTagsInput.vue'
import DropdownList from '@/components/utils/DropdownList.vue'
import CustomFileInput from '@/components/utils/CustomFileInput.vue'
import DatePicker from 'vue2-datepicker'

export default {
	props: {
		title: {
			type: String
		}
	},

	data () {
		return {
			newsfeed: {
				title: '',
				type: '',
				description: '',
				tags: {
					category: [],
					emotion: [],
					activity: [],
					subtag: []
				},
				date: null,
				time: null,
				media: {
					thumbnail: null,
					content: null
				}
			},

			categoryNameInputLength: 0,

			showCategoryList: false,
			showEmotionList: false,
			showActivityList: false,
			showSubtagList: false,

			options: {
				tags: {
					emotion: ['emotion 1', 'emotion 2', 'emotion 3'],
					activity: ['activity 1', 'activity 2', 'activity 3'],
					subtag: ['sub 1', 'sub 2', 'sub 3'],
					category: ['category 1', 'category 2', 'category 3']
				}
			}
		}
	},

	methods: {
		selectTag (tag, e) {
			console.log('select tag', tag, e)
			if (e) {
				this.newsfeed.tags[tag].push(e)
			}
		},

		inputTag (tag, e) {
			console.log('search tag', tag, e)

			if (tag === 'emotion') {
				this.showEmotionList = true
			}

			if (tag === 'activity') {
				this.showActivityList = true
			}

			if (tag === 'subtag') {
				this.showSubtagList = true
			}

			if (tag === 'category') {
				this.categoryNameInputLength = e.length
				this.showCategoryList = true
			}
		},

		removeTag (tag, e) {
			console.log('remove tag', tag, e)

			let index = this.newsfeed.tags[tag].indexOf(e)
			if (index > -1) this.newsfeed.tags[tag].splice(index, 1)
		}
	},

	components: {
		CustomTagsInput,
		DropdownList,
		CustomFileInput,
		DatePicker
	}
}
</script>

<style lang="scss" scoped>
.newsfeed-form {
    width: 1024px;
    background-color: #fff;
    padding: 0 20px;
    margin-bottom: 20px;

    header {
        @include flex-row(space-between, center);

        h3 {
            padding: 20px 0;
            color: $dark1;
        }

        .controls {
            > * {
                margin-left: 10px;
            }
        }
    }

    label, input, textarea {
        display: block;
        width: 100%;
    }

    label {
        margin-bottom: 10px;
    }

    .input-wrapper {
        margin-bottom: 15px;
    }

    textarea {
        height: 200px;
    }

    p.limit {
        margin-top: 5px;
        color: $dark;
        text-align: right;
        font-size: .85em;
    }

    section, .input-group {
        @include flex-row();
    }

    .input-group > * {
        flex:  1 1 auto;
    }

    section {
        border-top: 1px solid $light;
        padding: 20px 0 30px 0;

        > * {
            width: 45%;
            @include flex-column();
        }

        > *:first-child {
            margin-right: 5%;
        }
    }

    .input-group {
        @include flex-row();

        > *:not(:last-child) {
            margin-right: 20px;
        }
    }

    .upload-media-wrapper {
        flex: 1 1 auto;
        @include flex-column();
    }

    .upload-media {
        flex: 1 1 auto;
        @include flex-column();
        background-color: $light2;
        padding: 10px;

        h4 {
            padding: 10px 0 20px 0;
            border-bottom: 1px solid $light;
            margin-bottom: 20px;
        }

        p {
            font-style: italic;
            margin-bottom: 10px;
            color: $dark;
        }

        .file-input-container {
            flex: 1 1 auto;
        }
    }

    .radio-input {
        position: relative;

        input[type=radio] {
            position: absolute;
            width: 0;
            height: 0;
            opacity: 0;

        }

        span {
            background-color: $light;
            padding: 10px;
            display: block;
            text-align: center;
            user-select: none;
            cursor: pointer;
        }

        input[type=radio]:checked + span {
            background-color: $primary;
            color: #fff;
        }

    }

    /deep/ .tags-input {
        .item {
            background-color: $primary;
            color: #fff;
            border-radius: 5px;
            padding: 2px 5px;
        }
    }

    .dropdown-wrapper {
        position: relative;

        .dropdown-list {
            position: absolute;
            width: 100%;
            bottom: 0;
            margin-bottom: 10px;
            border-color: $primary;
        }
    }
}
</style>
